<template>
	<Layout :pageTitle="'Dashboard'">
		<template #breadcrumb>
			<router-link tag="li" to="/" class="breadcrumb-item active"><i class="icon icon-home-1"></i></router-link>
		</template>

		<Loader :show="loading" type="inline" />

		<div class="main-container container-fluid" v-if="accountDashboard">
			<div class="row row-xs mt-2">
				<div class="col-12 col-md-9">
					Proximo evento...<br />
					listado de ultimas entradas vendidas<br />
					{{ accountDashboard }}
				</div>
				<div class="col-12 col-md-3">
					<div class="card">
						<div class="card-body ">
							<div class="p-2 ">
								<div class="label">Dinero disponible</div>
								<h2>
									{{ accountDashboard.account.currencySymbol }}
									{{ accountDashboard.released | toCurrency }}
								</h2>
								<p class="text-secondary">
									A liberar
									{{ accountDashboard.account.currencySymbol }}
									{{ accountDashboard.toRelease | toCurrency }}
								</p>
								<hr />
								<router-link tag="a" to="/withdraws/request" class="btn btn-block btn-secondary"
									>Retirar dinero</router-link
								>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "dashboard",
	components: {},
	data() {
		return {
			accountDashboard: null,
			loading: false
		}
	},
	beforeMount() {
		this.loading = true
		this.load()
	},
	methods: {
		load() {
			this.$apollo
				.query({
					query: gql`
						query {
							accountDashboard {
								account {
									name
									currencySymbol
								}
								released
								toRelease
							}
						}
					`,
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.accountDashboard = data.accountDashboard
					this.loading = false
				})
		}
	}
}
</script>

<style scoped lang="scss"></style>
